<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: 0,
      }"
      show-footer
      :footer-span-method="footerColspanMethod"
      :footer-method="footerMethod"
    >
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { add, format } from '@/libs/util.number.js'

export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('form_label_chargeType') || '费用类型',
          field: 'chargeType',
          minWidth: 160,
          align: 'center',
        },
        {
          title: this.$l('form_label_charge_amount') || '含税金额',
          field: 'v_amount',
          minWidth: 170,
          align: 'center',
        },
      ],
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return []
      if (this.tableData.length <= 0) return []
      const sumData = this.tableData
        .map((item) => item.amount)
        .reduce((r, n) => add(r, n), 0)
      let footerRow = [this.$l('INDEX.total') || '合计', '', format(sumData)]
      return [footerRow]
    },
  },
  methods: {
    footerMethod() {
      return this.footerData
    },
    footerColspanMethod({ _columnIndex }) {
      if (_columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2,
        }
      } else if (_columnIndex == 1) {
        return {
          rowspan: 0,
          colspan: 0,
        }
      }
    },
  },
}
</script>
